// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mg_cR","primary":"Button_primary__PFIP8","secondary":"Button_secondary__kYMEY","tertiary":"Button_tertiary__FjYTD","full":"Button_full__qAdRb"};